import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Toast } from 'primereact/toast';
import * as actions from '../../store/actions/index';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import styles from '../batch/batchtable.module.css';
import { useHistory } from "react-router-dom";
import { AutoComplete } from 'primereact/autocomplete';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';


const Marksentry = (props) => {
    const marksstatus = [
        ' ',
        'Ab',
        'ZE',
        'UM'
    ];
    const toast = useRef(null);
    const dt = useRef(null);
    const history = useHistory();
    const [globalFilter, setGlobalFilter] = useState(null);
    const [currBatch, setCurrBatch] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(' ');
    const [filteredStatuses, setFilteredStatuses] = useState(null);
    const [marks, setMarks] = useState(history.location.state.batch.marks);

    useEffect(() => {
        setCurrBatch(history.location.state.batch);
        setMarks(history.location.state.batch.marks);
    },[history.location.state.batch]);

    const  entrySavedHandler = (e) => {
        e.preventDefault();
        if (props.isAuth) {
            const bdata = {
                status: currBatch.status,
                marks:currBatch.marks
            }
            props.onEntrySaved(currBatch._id,bdata,props.token);
            if (!props.loading) history.goBack();
        } else {
            history.push('/auth');
        }
    }

    const entrySubmitConfirm = (e) => {
        e.preventDefault();
        confirmDialog({
            message: 'Are you sure you want to Submit? Further Entries will NOT be allowed',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => entrySubmitHandler(),
            reject: () => rejectFunc()
        });
    }
    const rejectFunc = () => {
        return;
      }
      
    const entrySubmitHandler = (e) => {
        if (props.isAuth) {
            
            var chkall = true;
            for (var m in currBatch.marks) {
                if (currBatch.marks[m].award===0 && currBatch.marks[m].status===' ')
                    chkall=false;
            }
            if (!chkall) {
                alert("Batch Not Yet Completed..Cannot Submit, Use Save Instead")
                return;
            }

            const bdata = {
                status: 'submitted',
                marks:currBatch.marks
            }

            props.onEntrySubmit(currBatch._id,bdata,props.token);
            if (!props.loading) history.goBack();
        } else {
            history.push('/auth');
        }
    }
    const statusValidator = (e, o) => {
        let val=(!e.value)?' ':e.value
        const num = parseFloat(val);
        if(!isNaN(num) && isFinite(num)) {
            alert("Cannot Enter Marks in Status");
            o.rowData.status = ' ';
            return;
        }
        if (val.toLowerCase() === 'a' || val.toLowerCase() === ' a') val='A';
        else if (val.toLowerCase() === 'b' || val.toLowerCase() === ' b') val='b';
        else if (val.toLowerCase() === 'u' || val.toLowerCase() === ' u') val='U';
        else if (val.toLowerCase() === 'um' || val.toLowerCase() === 'um') val='UM';
        else if (val.toLowerCase() === 'z' || val.toLowerCase() === ' z') val='Z';
        else if (val.toLowerCase() === 'ze' || val.toLowerCase() === 'ze') val='ZE';
        else if (val.toLowerCase() === 'm' || val.toLowerCase() === ' m') val='M';
        else if (val.toLowerCase() === 'e' || val.toLowerCase() === ' e') val='E';
        if (o.rowData.award>0 && (val.trim() === 'Ab' || val.trim() === 'ZE')) {
            alert("Marks Obtained and Absent/Zero Cannot be together");
            o.rowData.status = ' ';
        }
        else 
            o.rowData.status = val
        //setSelectedStatus(val);
        }

    const awardValidator = (e,o) => {
        if (e.value > currBatch.mmarks) {
            alert("Marks Obtained Cannot be greater than Max marks");
            o.rowData.award=0;
        }
        else 
        if ((o.rowData.status.trim() === 'Ab' || o.rowData.status.trim() === 'ZE') && (e.value >0)) {
            alert("Marks Obtained and Absent/Zero Cannot be together");
            o.rowData.award=0;
        }
        else
            o.rowData.award = e.value || 0;
    }

    const marksEditor = (options) => {
        return <InputNumber inputStyle={{width:'50%'}} value={options.rowData.award} onValueChange={(e) => awardValidator(e,options)} min={0} max={currBatch.mmaks} />
    }
    const searchStatus = (event) => {
        setTimeout(() => {
            let _filteredStatuses;
            if (!event.query.length) {
                _filteredStatuses = [...marksstatus];
            }
            else {
                _filteredStatuses = marksstatus.filter((status) => {
                    return status.toLowerCase().includes(event.query.trim().toLowerCase());
                });
            }

            setFilteredStatuses(_filteredStatuses);
        }, 50);
    }
    const statusEditor = (options) => {
        //return <Dropdown value={selectedStatus} options={marksstatus} onFocus={(e) => setSelectedStatus(options.rowData.status)}  editable maxLength='3' onChange={(e) => statusValidator(e,options)}/>
        return <AutoComplete value={selectedStatus} suggestions={filteredStatuses} onblur={(e) => setSelectedStatus()} onFocus={(e) => setSelectedStatus(options.rowData.status)} completeMethod={searchStatus} dropdown forceSelection onChange={(e) => statusValidator(e,options)} ></AutoComplete>
    }   
    const header = (
        <div className={styles.tableheader}>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );

    // function keyGen(keyLength) {
    //     var i, key = "", characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    
    //     var charactersLength = characters.length;
    
    //     for (i = 0; i < keyLength; i++) {
    //         key += characters.substring(Math.floor((Math.random() * charactersLength) + 1), 1);
    //     }
    
    //     return key;
    // }
    return ( 
        <div >
            <Toast ref={toast} />
            <div className={styles.Sformpr} style={{position:'sticky', top:'0'}}>
                <div className=" ">
                    <label className="">Exam : <span style={{fontWeight:'bold'}}>{currBatch.exam}</span></label>
                    <label className="ml-4">Batch : <span style={{fontWeight:'bold'}}>{currBatch.batchcode}</span></label>
                    <label className="ml-4">Course : <span style={{fontWeight:'bold'}}>{currBatch.ccode}</span></label>
                    <label className="ml-4">Max Marks : <span style={{ fontWeight:'bold'}}>{currBatch.mmarks}</span></label>
                </div>
            </div>
            {props.loading?<ProgressSpinner/>:<div style={{width:'40%', margin:'auto'}} className={styles.datatablecruddemo}>
                <DataTable editMode="cell" resizableColumns columnResizeMode="fit" showGridlines className="p-datatable-sm" ref={dt} value={marks} 
                    paginator rows={20} rowsPerPageOptions={[20, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink  RowsPerPageDropdown"
                    globalFilter={globalFilter} header={header} responsiveLayout="scroll">

                    <Column field="controlno" header="Sch No" sortable style={{textAlign:'center',   width: '50%', padding:'0 1px 0 1px' }}></Column>
                    <Column key="award" field="award"  header="Marks" editor={(options) => marksEditor(options)} style={{textAlign:'center',   width: '23%' , padding:'0 1px 0 1px'}}></Column>
                    <Column key="status" field="status" sortable header="Status"  editor={(options) => statusEditor(options)} style={{textAlign:'center',   width: '23%' , padding:'0 1px 0 1px'}}></Column>
                </DataTable>
                <ConfirmDialog />
                <div className='flex flex-row justify-content-between'>   
                    <Button  label="Submit"  className="p-button-rounded p-button-raised p-button-success " onClick={entrySubmitConfirm} />
                    <Button  label="Save"  className="p-button-rounded p-button-raised p-button-warning " onClick={entrySavedHandler} />
                    <Button label="Back"  className="p-button-rounded p-button-danger" onClick={()=>history.goBack()} />
                </div>
            </div>}
        </div>
    );
}

const mapStatetoProps = (state) => {
    return {
        isAuth:state.auth.token!==null,
        token:state.auth.token,
        loading:state.batch.loading
    };
}

const mapDispatchtoProps = dispatch => {
    return {
        onEntrySaved: (id,bd,token) => dispatch(actions.saveBatch(id,bd,token)),
        onEntrySubmit: (id,bd,token) => dispatch(actions.submitBatch(id,bd,token)),
        onEntryCancelled: () => dispatch(actions.submitBatchSuccess()),
        // onInitIngredients: () => dispatch(actions.initIngredients()),
        // onInitPurchase: () => dispatch(actions.purchaseInit()),
        onSetAuthRedirectPath: (path) => dispatch(actions.setAuthRedirectPath(path))
    }
}

export default connect(mapStatetoProps, mapDispatchtoProps)(Marksentry);